import {api} from '../../system/api';

export default {
    getUser: () => api.get('auth/user'),
    getPartner: () => api.get('settings/general-detail'),
    login: (params) => api.get('login', {params}),
    getLimitedTimeToken: () => api.get('/users/token')
};
